/**
 * KB-META
 * Purpose: App routes
 * Role: guard
 * EntryPoints: 
 * Inputs: 
 * Outputs: 
 * Validation: 
 * Dependencies: 
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=src/app.routes; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { Routes } from '@angular/router';
// import { DefaultLayoutComponent } from './layout';
import { AppLayout } from './app/layout/component/app.layout';
import { AuthGuard } from './app/guard/auth.guard';
import { UnsavedChangesGuard } from './app/guards/unsaved-changes.guard';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'genus-connect/care-manager-dashboard',
    pathMatch: 'full'
  },
  {
    // Embedded Patient Edit V2 for dashboard "quick view" popovers (no AppLayout chrome)
    path: 'embed/patient-edit-2/:id',
    loadComponent: () => import('./app/views/genus-connect/patient-edit-2/patient-edit-2.component').then(m => m.PatientEdit2Component),
    canActivate: [AuthGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      title: 'Edit Patient V2 (Quick View)'
    }
  },
  {
    path: '',
    component: AppLayout,
    canActivate: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./app/views/playground/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin', 'partner', 'user']
        }
      },
      {
        path: 'setting',
        loadChildren: () => import('./app/views/setting/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin']
        }
      },
      {
        path: 'account',
        loadChildren: () => import('./app/views/account/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin', 'partner']
        }
      },
      {
        path: 'team',
        loadChildren: () => import('./app/views/team/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin', 'partner']
        }
      },
      {
        path: 'content',
        loadChildren: () => import('./app/views/content/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin', 'contentadmin']
        }
      },
      {
        path: 'genus-direct',
        loadChildren: () => import('./app/views/genus-direct/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin', 'partner', 'user']
        }
      },
      {
        path: 'genus-connect',
        loadChildren: () => import('./app/views/genus-connect/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin', 'partner', 'user']
        }
      },
      {
        path: 'mingle-coach',
        loadChildren: () => import('./app/views/mingle-coach/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin', 'partner', 'user']
        }
      },
      {
        path: 'resources',
        loadChildren: () => import('./app/views/resources/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin', 'partner', 'user']
        }
      },
      {
        path: 'analytics',
        loadChildren: () => import('./app/views/analytics/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin', 'partner']
        }
      },
      {
        path: 'genusmedia',
        loadChildren: () => import('./app/views/genusmedia/routes').then((m) => m.routes),
        data: {
          expectedRole: ['admin']
        }
      }
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./app/views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./app/views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    loadComponent: () => import('./app/views/pages/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    loadComponent: () => import('./app/views/pages/register/register.component').then(m => m.RegisterComponent),
    data: {
      title: 'Register Page'
    }
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./app/views/pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
    data: {
      title: 'Register Page'
    }
  },
{
  path: 'confirm-password',
  loadComponent: () => import('./app/views/pages/confirm-password/confirm-password.component').then(m => m.ConfirmPasswordComponent),
  data: {
    title: 'Forgot Password Page'
  }
},

  {
    path: 'multifactor',
    loadComponent: () => import('./app/views/pages/multifactor/multifactor.component').then(m => m.MultifactorComponent),
    data: {
      title: 'MFA Page'
    }
  },
  {
    path: 'public-register',
    loadComponent: () => import('./app/views/pages/public-register/public-register.component').then(m => m.PublicRegisterComponent),
    data: {
      title: 'Partner Registration'
    }
  },
  {
    path: 'signup', // Public-friendly URL
    redirectTo: 'public-register',
    pathMatch: 'full'
  },
  {
    path: 'stream/:id',
    loadComponent: () => import('./app/views/mingle-coach/components/stream-view/stream-view.component').then(m => m.StreamViewComponent),
    canActivate: [AuthGuard],
    data: {
      title: 'Live Stream',
      expectedRole: ['admin', 'partner', 'user']
    }
  },
  { path: '**', redirectTo: 'dashboard' }
];
